window.isYoutubeApiLoaded = false;

(function() {
    var LightboxVideoPlayer = {
        currentTrigger : null,
        lightboxElement : null,
        lightboxPlayerWrapperElement : null,
        lightboxBackgroundElement : null,
        lightboxCloseElement : null,

        youtubePlayerObject : null,

        isYoutubeApiLoaded : false,

        clearWrapper : function() {
            while (this.lightboxPlayerWrapperElement.firstChild) {
                this.lightboxPlayerWrapperElement.removeChild(this.lightboxPlayerWrapperElement.firstChild);
            }
        },

        onVideoReady : function() {
            if ( this.currentTrigger.type == "youtube" ) {
                this.lightboxPlayerWrapperElement.classList.add('playing');
                this.youtubePlayerObject.playVideo();
            }
        },
        
        onVideoStateChange : function(event) {
            if ( this.currentTrigger.type == "youtube" ) {
                if (event.data == YT.PlayerState.PLAYING ) {
                    this.youtubePlayerObject.stopVideo;
                }
            }
        },

        loadVideo : function(currentTrigger) {
            if ( this.currentTrigger == null || this.currentTrigger.videoId != currentTrigger.videoId ) {
                // TODO: Add Loading logic here
                this.currentTrigger = currentTrigger;
            }

            // Shorts open a portrait player; set before the player measures its wrapper.
            this.lightboxElement.classList.toggle('is-vertical', this.currentTrigger.aspect === '9:16');
            this.lightboxElement.classList.add('entering');
            this.currentTrigger.element.classList.add('hidden');

            var lightboxPlayer = document.createElement('div');
            lightboxPlayer.id = "lightbox-player";
            this.clearWrapper();
            this.lightboxPlayerWrapperElement.appendChild(lightboxPlayer);
            
            if ( this.currentTrigger.type == 'youtube' && ! window.isYoutubeApiLoaded ) {
                (function() {
                    var currentTrigger = this.currentTrigger;
                    window.onYouTubeIframeAPIReady = function() {
                        this.onYoutubeApiReady()
                    }.bind(this)
                }.bind(this))();
                this.loadYoutubeApi();
            } else if ( this.currentTrigger.type == 'youtube' ) {
                this.youtubePlayerObject = new YT.Player('lightbox-player', {
                    height:  '' + this.lightboxPlayerWrapperElement.offsetHeight,
                    width: '' + this.lightboxPlayerWrapperElement.offsetWidth,
                    videoId: this.currentTrigger.videoId,
                    events: {
                    'onReady': this.onVideoReady.bind(this),
                    'onStateChange': this.onVideoStateChange.bind(this)
                    }
                });
            }
        },

        closeVideoPlayer : function() {
            this.youtubePlayerObject.pauseVideo();
            this.currentTrigger.element.classList.remove('hidden');
            this.lightboxElement.classList.add('leaving');
            setTimeout( function() {
                this.lightboxElement.classList.remove('entering');
                this.lightboxElement.classList.remove('leaving');
                this.lightboxElement.classList.remove('is-vertical');
            }.bind(this), 750);
        },

        loadYoutubeApi : function(currentTrigger) {
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        },

        onYoutubeApiReady : function() {
            window.isYoutubeApiLoaded = true;
            this.loadVideo(LightboxVideoPlayer.currentTrigger);
        },

        addEventListeners : function() {
            this.lightboxCloseElement.addEventListener('click', function(e) {
                this.closeVideoPlayer();
            }.bind(this));
        },

        init : function() {
            this.lightboxElement = document.querySelector('#video-player-lightbox');
            this.lightboxPlayerWrapperElement = this.lightboxElement.querySelector('.lightbox-player-wrapper');
            this.lightboxBackgroundElement = this.lightboxElement.querySelector('.lightbox-background');
            this.lightboxCloseElement = this.lightboxElement.querySelector('.lightbox-close-button');
            this.addEventListeners();
        }
    };

    var YoutubeVideoPlayer = {

        currentTrigger : null,

        youtubePlayerObject : null,

        isYoutubeApiLoaded : false,

        onVideoReady : function() {
            this.currentTrigger.element.classList.add('hidden');
            if ( this.currentTrigger.type == "youtube" ) {
                this.currentTrigger.inlineVideoPlayer
                if ( this.currentTrigger.autoplay ) {
                    this.youtubePlayerObject.mute();
                }
                this.youtubePlayerObject.playVideo();
            }
        },
        
        onVideoStateChange : function(event) {
            if ( this.currentTrigger.type == "youtube" ) {
                if (event.data == YT.PlayerState.PLAYING ) {
                    // this.youtubePlayerObject.stopVideo;
                    this.currentTrigger.element.classList.add('playing');
                } else if ( event.data == YT.PlayerState.PAUSED ) {
                    this.currentTrigger.element.classList.add('paused');
                    this.currentTrigger.element.classList.remove('playing');
                } else if ( event.data === YT.PlayerState.ENDED ) {
                    if ( this.currentTrigger.autoplay ) {
                        this.youtubePlayerObject.playVideo(); 
                    }
                }
            }
        },

        loadVideo : function(currentTrigger) {

            if ( this.currentTrigger.type == 'youtube' && ! window.isYoutubeApiLoaded ) {
                this.loadYoutubeApi();
            } else if ( this.currentTrigger.type == 'youtube' ) {
                var playerVars = {
                    rel: 0,
                    modestbranding : 1,
                    autoplay : this.currentTrigger.autoplay ? 1 : 0,
                    loop : this.currentTrigger.autoplay ? 1 : 0
                }
                this.youtubePlayerObject = new YT.Player(this.currentTrigger.inlineVideoPlayer, {
                    height:  '' + this.currentTrigger.inlineVideoPlayer.offsetHeight,
                    width: '' + this.currentTrigger.inlineVideoPlayer.offsetWidth,
                    videoId: this.currentTrigger.videoId,
                    playerVars : playerVars,
                    events: {
                    'onReady': this.onVideoReady.bind(this),
                    'onStateChange': this.onVideoStateChange.bind(this)
                    }
                });

            }
        },


        loadYoutubeApi : function(currentTrigger) {
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        },

        onYoutubeApiReady : function() {
            window.isYoutubeApiLoaded = true;
            this.loadVideo();
        },

        init : function(currentTrigger) {
            this.currentTrigger = currentTrigger;
            if ( window.isYoutubeApiLoaded == false )  {
                (function() {
                    var currentTrigger = this.currentTrigger;
                    window.onYouTubeIframeAPIReady = function() {
                        window.isYoutubeApiLoaded = true;
                        this.onYoutubeApiReady()
                    }.bind(this)
                }.bind(this))();
            } 

            this.loadVideo(this.currentTrigger);
        }   
    };

    function VideoPlayer(wrapper) {
        this.elements = {
            wrapper : wrapper,
            inner : wrapper.querySelector('.video__inner'),
            player : wrapper.querySelector('.video__player'),
            background : wrapper.querySelector('.video__background')
        },
        this.state = {
            waitingForPlayPromise : false,
            waitingForPause : false,
            waitingForPlay : true,
            isPlayerReady : false,
        },
        this.playVideo = function() {
            if ( !this.state.isPlayerReady ) {
                this.state.waitingForPlay = true;
            }
            this.state.waitingForPlayPromise = true;
            var playPromise = this.elements.player.play();
            if ( playPromise == null ) {
                playPromise = new Promise(function(resolve, reject) {
                    resolve();
                });
            }
            playPromise.then(function(){
                this.state.waitingForPlayPromise = false;
                if ( this.state.waitingForPause ) {
                    this.pauseVideo();
                }
            }.bind(this));
        };
        this.pauseVideo = function() {
            if ( this.state.waitingForPlayPromise ) {
                this.state.waitingForPause = true;
            } else {
                console.log("pausing video");
                this.elements.player.pause();
            }
        };
        this.loadVideo = function() {
            if ( !this.state.isPlayerReady ) {
                this.state.isPlayerReady = true;
                this.elements.player.src = this.state.src;

                if ( this.state.waitingForPlay ) {
                    this.playVideo();
                }
            }
        };
        this.initializePlayer = function() {
            var player = document.createElement('video');
            player.classList.add('video__player');
            
            this.state.src = this.elements.wrapper.getAttribute('data-video-src');

            if ( this.elements.wrapper.hasAttribute('data-video-muted') ) {
                this.state.muted = true;
                player.muted = true;
                player.setAttribute('muted', '');
            }
            if ( this.elements.wrapper.hasAttribute('data-video-loop') ) {
                this.state.loop = true;
                player.loop = true;
                player.setAttribute('loop', '');
            }
            if ( this.elements.wrapper.hasAttribute('data-video-autoplay') ) {
                this.state.muted = true;
                player.muted = true;
                player.setAttribute('muted', '');

                this.state.autoplay = true;
                player.setAttribute('playsinline', '');
            }

            this.elements.inner.replaceChild(player, this.elements.player);
            this.elements.player = player;
        }
        this.addEventListener = function() {
        };
        this.init = function() {
            this.state.id = this.elements.wrapper.getAttribute('data-video-id');
            this.initializePlayer();
        };
    }

    function VideoPlayersController() {
        this.state = {
            players : []
        };
        this.playVideo = function(id) {
            for ( var playerIndex = 0; playerIndex < this.state.players.length; playerIndex++ ) {
                var currentPlayer = this.state.players[playerIndex];
                var playerId = currentPlayer.state.id;
                if ( playerId == id ) {
                    currentPlayer.playVideo();
                }
            }
        };
        this.pauseVideo = function(id) {
            for ( var playerIndex = 0; playerIndex < this.state.players.length; playerIndex++ ) {
                var currentPlayer = this.state.players[playerIndex];
                var playerId = currentPlayer.state.id;
                if ( playerId == id ) {
                    currentPlayer.pauseVideo();
                }
            }
        };
        this.loadVideo = function(id) {
            for ( var playerIndex = 0; playerIndex < this.state.players.length; playerIndex++ ) {
                var currentPlayer = this.state.players[playerIndex];
                var playerId = currentPlayer.state.id;
                if ( playerId == id ) {
                    console.log('loading video ', id);
                    currentPlayer.loadVideo();
                }
            }

        }
        this.handleVideoObservation = function(entries, observer) {
            var activeGroups = {};
            var entryThreshold = 0.1;
            entries.forEach( function(entry) {
                if ( entry.intersectionRatio >= (parseFloat(entryThreshold) - 0.001) && entry.target.hasAttribute('data-video-autoplay')) {
                    window.wghi.VideoPlayersController.playVideo(entry.target.getAttribute('data-video-id'));
                } else {
                    window.wghi.VideoPlayersController.pauseVideo(entry.target.getAttribute('data-video-id'));
                }
            });
        };
        this.handleVideoLoadObservation = function(entries, observer) {
            var activeGroups = {};
            var entryThreshold = 0.1;
            entries.forEach( function(entry) {
                if ( entry.intersectionRatio >= (parseFloat(entryThreshold) - 0.001)) {
                    window.wghi.VideoPlayersController.loadVideo(entry.target.getAttribute('data-video-id'));
                    observer.unobserve(entry.target);
                }
            });
        };
        this.observeVideoPlayers = function() {
            var videoLoadObserverOptions = {
                threshold : 0.1,
                rootMargin : '0px 0px ' + window.innerHeight * 2 + 'px 0px'
            };
            var videoObserverOptions = {
                threshold : 0.1,
                rootMargin : '0px 0px 0px 0px'
            };
            var videoLoadObserver = new IntersectionObserver(this.handleVideoLoadObservation, videoLoadObserverOptions);
            var videoPlayObserver = new IntersectionObserver(this.handleVideoObservation, videoObserverOptions);
            for ( var i = 0; i < this.state.players.length; i++ ) {
                var observedElement = this.state.players[i].elements.wrapper;
                videoPlayObserver.observe(observedElement);
                if ( window.wghi.helpers.getOffsetTop(observedElement) > (window.pageYOffset + window.innerHeight) ) {
                    console.log("Observing");
                    videoLoadObserver.observe(observedElement);
                } else {
                    this.loadVideo(observedElement.getAttribute('data-video-id'));
                }
            }

        };
        this.init = function() {
            var playerWrappers = document.querySelectorAll('[data-video-player]');
            for ( var playerIndex = 0; playerIndex < playerWrappers.length; playerIndex++ ) {
                var currentPlayerWrapper = playerWrappers[playerIndex];
                var currentPlayer = new VideoPlayer(currentPlayerWrapper);
                currentPlayer.init();
                this.state.players.push(currentPlayer);
            }
            this.observeVideoPlayers();
        }
    }

    var VideoPlayerConfig = {
        videoPlayerTriggers : [],
        videoPlayers : [],
        callbacks : {},

        resetConfig : function() {
            for (var i = 0; i < this.videoPlayerTriggers.length; i++) {
                if ( this.videoPlayerTriggers[i].inlineVideoPlayer ) {
                    var currentTrigger = this.videoPlayerTriggers[i];
                    if ( !currentTrigger.element.hasAttribute('video-autoplay') ) {
                        this.callbacks.handleTriggerClick = this.handleTriggerClick.bind(this)
                        currentTrigger.element.removeEventListener('click', this.callbacks.handleTriggerClick);
                    }
                } else {
                    var currentTrigger = this.videoPlayerTriggers[i];
                    this.callbacks.handleInlineTriggerClick = this.handleInlineTriggerClick.bind(this);
                    currentTrigger.element.removeEventListener('click', this.callbacks.handleInlineTriggerClick);
                }
            }
            this.init();
        },
        
        handleTriggerClick : function(e) {
            var youtubeVideoPlayer = Object.assign({}, YoutubeVideoPlayer);
            youtubeVideoPlayer.init(this.videoPlayerTriggers[e.currentTarget.getAttribute('trigger-index')]);
            this.videoPlayers = youtubeVideoPlayer;
        },

        handleInlineTriggerClick : function(e) {
            LightboxVideoPlayer.loadVideo(this.videoPlayerTriggers[e.currentTarget.getAttribute('trigger-index')]);

        },

        addEventListeners : function() {
            for (var i = 0; i < this.videoPlayerTriggers.length; i++) {
                if ( this.videoPlayerTriggers[i].inlineVideoPlayer ) {
                    (function() {
                        var currentTrigger = this.videoPlayerTriggers[i];
                        if ( currentTrigger.element.hasAttribute('video-autoplay') ) {
                            var youtubeVideoPlayer = Object.assign({}, YoutubeVideoPlayer);
                            youtubeVideoPlayer.init(currentTrigger)
                            this.videoPlayers = youtubeVideoPlayer;
                        } else {
                            currentTrigger.element.setAttribute('trigger-index', i);
                            this.callbacks.handleTriggerClick = this.handleTriggerClick.bind(this)
                            currentTrigger.element.addEventListener('click', this.callbacks.handleTriggerClick);
                        }
                    }.bind(this))()
                } else {
                    (function() {
                        var currentTrigger = this.videoPlayerTriggers[i];
                        currentTrigger.element.setAttribute('trigger-index', i);
                        this.callbacks.handleInlineTriggerClick = this.handleInlineTriggerClick.bind(this);
                        currentTrigger.element.addEventListener('click', this.callbacks.handleInlineTriggerClick);
                    }.bind(this))()
                }
            }
        },

        getVideoId : function(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(shorts\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            var match = url.match(regExp);
            return (match&&match[8].length==11)? match[8] : false;
        },

        init : function() {
            var videoPlayerTriggers = document.querySelectorAll('[video-player-trigger]');
            for ( var i = 0; i < videoPlayerTriggers.length; i++ ) {
                var currentTriggerElement = videoPlayerTriggers[i];
                var currentInlineVideoPlayer = currentTriggerElement.querySelector('[video-player-inline]');
                var videoId = this.getVideoId(currentTriggerElement.getAttribute('video-url'));
                if ( !videoId ) {
                    console.error('Could not find Youtube Video ID');
                } else {
                    var currentTrigger = {
                        element : currentTriggerElement,
                        inlineVideoPlayer : currentInlineVideoPlayer,
                        videoId : videoId,
                        type : currentTriggerElement.getAttribute('video-player-type'),
                        aspect : currentTriggerElement.getAttribute('video-aspect'),
                        autoplay : currentTriggerElement.hasAttribute('video-autoplay')
                    }
                    this.videoPlayerTriggers.push(currentTrigger);

                }
            }
            this.addEventListeners();
        }
    }
    
    window.wghi.LightboxVideoPlayer = LightboxVideoPlayer;
    window.wghi.VideoPlayerConfig = VideoPlayerConfig;
    window.wghi.VideoPlayersController = new VideoPlayersController();

    document.addEventListener('DOMContentLoaded', function() {
        window.wghi.LightboxVideoPlayer.init();
        window.wghi.VideoPlayerConfig.init();
        window.wghi.VideoPlayersController.init();
    });
})();
